import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Constants, feedBackApiUrl, feedBackAppId } from 'src/app/helper/constants';
import {
  IUserRootObject,
  IUser,
  IRecentCheckInRootObject,
  IActiveCheckInRootObject,
  IInviteExternalUser,
  IUserPermissionRootObject,
  IUserPermissionFacilitiesRootObject
} from 'src/app/models/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient) {
    // Do Nothing
  }

  apiError = new Subject();

  fetchUserDetails(): Observable<IUserRootObject> {
    return this.httpClient.get<IUserRootObject>(Constants.GET_USER_DETAILS);
  }

  postUserData = (userData: IUser): Observable<IUserRootObject> => {

    const empNumber = userData.extension_8b4e685f580748b59864d62c2e7fcfad_employeeNumber;
    const obj = {
      alias: userData.extension_8b4e685f580748b59864d62c2e7fcfad_sAMAccountName,
      gin: empNumber === undefined ? '000000000' : empNumber, // send 000000000 in case of contractor.
      name: userData.displayName,
      jobTitle: userData.jobTitle,
      email: userData.userPrincipalName,
      orgUnit: userData.extension_8b4e685f580748b59864d62c2e7fcfad_msDS_cloudExtensionAttribute6,
      businessArea: userData.extension_8b4e685f580748b59864d62c2e7fcfad_msDS_cloudExtensionAttribute10,
      employeeType: userData.extension_8b4e685f580748b59864d62c2e7fcfad_employeeType,
      managerAlias: userData.managerAlias,
      managerGin: userData.managerGin,
      managerName: userData.managerName,
      managerEmail: userData.managerEmail
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    return this.httpClient.post<IUserRootObject>(Constants.POST_USER_DETAILS, obj, options);
  }

  getRecentCheckinData = (): Observable<IRecentCheckInRootObject> => {
    return this.httpClient.get<IRecentCheckInRootObject>(Constants.GET_RECENT_TWO);
  }

  getActiveCheckinData = (): Observable<IActiveCheckInRootObject> => {
    return this.httpClient.get<IActiveCheckInRootObject>(Constants.GET_ACTIVE_CHECKINS);
  }

  getActiveCheckinForSiteRequestData = (param: string): Observable<IActiveCheckInRootObject> => {
    return this.httpClient.get<IActiveCheckInRootObject>(Constants.GET_ACTIVE_CHECKINS + '?emailOrPhone=' + param + '&isQRScan=true');
  }

  postlanguageData = (languages: string): Observable<IUserRootObject> => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    return this.httpClient.post<IUserRootObject>(Constants.POST_LANGUAGE_DETAILS + languages, options);
  }

  changePassword = (oldpassword, newpassword): Observable<any> => {
    const headers = new HttpHeaders({
      OldPassword: btoa(oldpassword),
      NewPassword: btoa(newpassword)
    });
    const options = { headers };
    return this.httpClient.post<any>(Constants.CHANGE_PASSWORD, {}, options);
  }

  getHRApiDetails = (): Observable<any> => {
    return this.httpClient.get<any>(Constants.HR_API_DETAILS);
  }

  getUserPermissionMapping = (): Observable<IUserPermissionRootObject> => {
    return this.httpClient.get<IUserPermissionRootObject>(Constants.USER_PERMISSION_MAPPING);
  }

  getUserPermissionMappingFacilities = (permissionId: number): Observable<IUserPermissionFacilitiesRootObject> => {
    return this.httpClient.get<IUserPermissionFacilitiesRootObject>(Constants.USER_PERMISSION_MAPPING_FACILTIES + permissionId.toString());
  }

  searchExternalUsers = (query: string): Observable<any> => {
    return this.httpClient.get<any>(Constants.SEARCH_EXTERNAL_USERS + query);
  }

  inviteExternalUsers = (inviteUser: IInviteExternalUser): Observable<IUserRootObject> => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    return this.httpClient.post<IUserRootObject>(Constants.INVITE_EXTERNAL_USERS, inviteUser, options);
  }

  setError(error: Error) {
    this.apiError.next(error);
  }

  listenApiError(): Observable<any> {
    return this.apiError.asObservable();
  }


  getUSSFeedbackStatus(alias: string): Observable<any> {
    let params = new HttpParams();
    params = params.append('strAID', feedBackAppId());
    params = params.append('strUserID', alias);
    return this.httpClient.get(feedBackApiUrl(), {
      params
    })
  };

}
